/**
 * Build version — proposal §3.4 (Q13a default) renders "Smart Invoice
 * Health · build {version}" in the quiet footer.
 *
 * The version is sourced from `package.json` at build time via Vite's
 * `define` plugin (configured in vite.config.ts). The string is exposed
 * as a regular const so tests can import and assert against it.
 */

declare const __APP_BUILD_VERSION__: string

export const APP_BUILD_VERSION: string = __APP_BUILD_VERSION__
